module.exports = __webpack_public_path__ + "img/dynamic-19.9457e4ab.png";